<script>
import Thumbnail from '../../../components/widgets/Thumbnail.vue';

export default {
  components: {
    Thumbnail,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    thumbnail: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    identifier: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<template>
  <div class="option-item--user">
    <Thumbnail :src="thumbnail" size="28px" :username="name" />
    <div class="option__user-data">
      <h5 class="option__title">
        {{ name }}
        <span v-if="identifier" class="user-identifier">
          {{ $t('MERGE_CONTACTS.DROPDOWN_ITEM.ID', { identifier }) }}
        </span>
      </h5>
      <p class="option__body">
        <span v-if="email" class="email-icon-wrap">
          <fluent-icon class="merge-contact--icon" icon="mail" size="12" />
          {{ email }}
        </span>
        <span v-if="phoneNumber" class="phone-icon-wrap">
          <fluent-icon class="merge-contact--icon" icon="call" size="12" />
          {{ phoneNumber }}
        </span>
        <span v-if="!phoneNumber && !email">{{ '---' }}</span>
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.option-item--user {
}
.user-identifier {
}
.option__user-data {
}
.option__body,
.option__title {
}
.option__body .icon {
}
.option__title {
}
.option__body {
}

.option__user-data .option__body {
  > .phone-icon-wrap,
  > .email-icon-wrap {
  }
}

.merge-contact--icon {
}
</style>
